<template>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="container login">
        <div class="row">
          <div class="mx-auto d-flex flex-column justify-content-center align-items-center h100">
            <div class="card card-plain w-100">
              <CompanyLogo />
              <div class="card-body">
                <form action class="form" @submit.prevent="login">
                  <!-- <div class="form-group">
                    <label class="form-label" for="#email"> Correo Electrónico <span class="red">*</span> </label>
                    <input v-model="email" class="form-input form-control form-control-default invalid" name="email" id="email" required placeholder="Ingrese su email" />
                  </div> -->
                  <div class="form-group">
                    <label class="form-label" for="#email"> Usuario <span class="red">*</span> </label>
                    <input v-model="email" class="form-input form-control form-control-default invalid" name="email" id="email" required placeholder="Ingrese su nombre de usuario" />
                  </div>
                  <!--  <div class="form-group">
                    <label class="form-label" for="#company"> Compañía <span class="red">*</span> </label>
                    <input v-model="company" class="form-input form-control form-control-default invalid" name="company" id="company" placeholder="Ingrese su compañía" />
                  </div> -->
                  <div class="form-group">
                    <label class="form-label" for="#password">Contraseña <span class="red">*</span></label>
                    <div class="input-group">
                      <input v-model="password" class="form-input form-control form-control-default invalid" name="password" type="password" id="password" placeholder="Ingrese su contraseña" ref="passwordInput" @input="password = $event.target.value" />
                      <div class="input-group-append"><span class="input-group-text" @click="togglePasswordVisibility()"> <i :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i></span></div>
                    </div>
                  </div>
                  <TurnstileWidget
                    :site-key="site_key"
                    v-model="recaptchaToken"
                    @error="recaptchaError"
                    ref="turnstile"
                    theme="light"
                    class="pt-3 pb-1 d-flex justify-content-center"
                  />
                  <div><p class="red small mt-4" v-if="incorrectAuth">{{ errorMessage }}</p></div>
                  <div class="mt-4 mb-2 d-flex justify-content-between">
                    <div class="form-check">
                      <input id="rememberMe" v-model="rememberMe" class="form-check-input" type="checkbox" />
                      <label for="rememberMe" class="custom-control-label">Recordarme</label>
                    </div>
                    <div><router-link class="small" :to="{ name: 'PasswordRecovery' }">¿Olvidaste tu contraseña?</router-link></div>
                  </div>
                  <VsudButtonVue color="primary" size="lg" fullWidth="true" value="Login" type="submit" class="form-submit mt-4 mb-3" :load="load">Iniciar Sesión</VsudButtonVue>
                </form>
                <SocialNetworkVue :textMessage="textMessage" />
                <!-- <FinalLoginMessage :finalLoginText="finalLoginText" :finalLoginLinkText="finalLoginLinkText" :finalLoginLink="finalLoginLink" /> -->
              </div>
            </div>
            <!-- <DownloadAppVue /> -->
          </div>
        </div>
      </div>
    </section>
    <BackgroundCarrusel />
  </main>
</template>

<script>
import CryptoJS from 'crypto-js';
const body = document.getElementsByTagName("body")[0];
import TurnstileWidget from "@/components/TurnstileWidget.vue";

import VsudButtonVue from "@/components/VsudButton.vue";
import CompanyLogo from "@/components/CompanyLogo.vue";
import SocialNetworkVue from './Log/SocialNetwork.vue';
/* import DownloadAppVue from './Log/DownloadApp.vue'; */
import BackgroundCarrusel from './Log/BackgroundCarrusel.vue';
import axios from 'axios'
import base from './../config/base';

export default {
  name: "LoginPage",
  inject: ["api_provider", "urls_server", "securedWebStorage"],
  components: {
    CompanyLogo,
    VsudButtonVue,
    SocialNetworkVue,
    /* DownloadAppVue, */
    BackgroundCarrusel,
    TurnstileWidget
  },

  data() {
    return {
      email: "",
      password: "",
      rememberMe: false,
      showPassword: false,
      incorrectAuth: false,
      finalLoginText: "¿Aún no tienes cuenta?",
      finalLoginLinkText: "Regístrate",
      finalLoginLink: "/createaccount",
      textMessage: "O inicia sesión con",
      errorMessage: 'Se ha producido un problema al intentar ingresar, intente mas tarde',
      load: false,
      site_key: base.SITE_KEY,
      recaptchaToken: "",
      isPosting: false
    };
  },
  beforeMount() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    if (body) {
      body.classList.remove("bg-gray-100");
    }

    // Cargar credenciales almacenadas si existen
    const encryptedEmail = localStorage.getItem("email") || sessionStorage.getItem("email");
    const encryptedPassword = localStorage.getItem("password") || sessionStorage.getItem("password");
    const rememberMe = localStorage.getItem("rememberMe");

    if (rememberMe && JSON.parse(rememberMe)) {
      if (encryptedEmail && encryptedPassword) {
        this.email = this.decryptData(encryptedEmail);
        this.password = this.decryptData(encryptedPassword);
      }
    }
    if (rememberMe) {
      this.rememberMe = JSON.parse(rememberMe);
    }
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    // this.get_menu()

    if (body) {
      body.classList.add("bg-gray-100");
    }
  },
  computed: {
    // Derivado del token y no una bandera aparte: el watch anterior solo la ponia en
    // true, asi que cuando el widget se reiniciaba solo (cada 295 s) el token quedaba
    // vacio pero la bandera seguia encendida. El formulario se enviaba sin captcha y el
    // back lo rechazaba con un error que al usuario no le decia nada.
    recaptchaVerified() {
      return Boolean(this.recaptchaToken);
    }
  },
  methods: {
    // async get_menu(){
    //   const response = await this.api_provider.post(this.urls_server.get_menu, {}, "get", null, 60000);
    //   this.securedWebStorage.setItem("menuModules", JSON.stringify(response.data.menu_modules));
    // },
    encryptData(data) {
      return CryptoJS.AES.encrypt(data, base.config.SECRET_KEY).toString();
    },
    decryptData(data) {
      const bytes = CryptoJS.AES.decrypt(data, base.config.SECRET_KEY);
      return bytes.toString(CryptoJS.enc.Utf8);
    },
    recaptchaError(code) {
      console.error("[Turnstile] error:", code);
      this.recaptchaToken = "";
    },
    resetRecaptcha() {
      this.recaptchaToken = "";
      if (this.$refs.turnstile) {
        this.$refs.turnstile.reset();
      }
    },
    async login() {
      try {
        if (!this.recaptchaVerified) {
          this.errorMessage = 'Por favor, verifica el reCAPTCHA.';
          this.resetRecaptcha();
          this.incorrectAuth = true;
          return;
        }

        // Validar si ya hay una consulta pendiente
        if (this.isPosting) {
          return;
        }

        // Marcar que la solicitud está en proceso
        this.isPosting = true;

        // Limpia cualquier sesión previa (los tokens ahora viven en cookies HttpOnly del BFF)
        this.securedWebStorage.deleteItem("access");
        this.securedWebStorage.deleteItem("refresh");

        const postData = { username: this.email, password: this.password, recaptchaToken: this.recaptchaToken };
        const response = await this.api_provider.postLogin(this.urls_server.login, postData);

        if (response.data && response.data.user) {
          const { company, user } = response.data;

          // Guardar estado de "Recordarme"
          localStorage.setItem("rememberMe", JSON.stringify(this.rememberMe));

          if (this.rememberMe) {
            localStorage.setItem("email", this.encryptData(this.email));
            localStorage.setItem("password", this.encryptData(this.password));
            sessionStorage.removeItem("email");
            sessionStorage.removeItem("password");
          } else {
            localStorage.removeItem("email");
            localStorage.removeItem("password");
            sessionStorage.setItem("email", this.encryptData(this.email));
            sessionStorage.setItem("password", this.encryptData(this.password));
          }

          this.$store.commit("setSession", user);
          this.$store.commit("setIdCompany", company);

          const user_url = user.url;

          // El login fue exitoso (hay access token). Redirige a su dashboard;
          // si el usuario no tiene una URL asignada, cae a /dashboard por defecto.
          this.load = true;
          this.$emit("update:load", true);

          setTimeout(() => {
            this.$router.push({ path: user_url || "/dashboard" });
          }, 1500);
        }
      } catch (error) {
        console.log("Login ERROR" , error)
        this.incorrectAuth = true;
        this.$emit("update:load", false);
        this.errorMessage = error.response?.status === 401
          ? error.response.data.detail
          : "Se ha producido un problema al intentar ingresar, intente más tarde";
      } finally {
        // console.log("entra aca")
        this.cleanError()
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
      if (this.showPassword) {
        this.$refs.passwordInput.type = "text";
      } else {
        this.$refs.passwordInput.type = "password";
      }
    },
    cleanError() {
      this.resetRecaptcha();
      this.isPosting = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/responsive" as r;

.login {
  width: 100%;
  min-height: 100lvh;
  background-color: var(--background);
  position: relative;
  z-index: 1;
}

main {
  display: flex;
  flex-direction: row-reverse;
}

/* Teléfono + tablet: formulario centrado */
@include r.mobile {
  main {
    justify-content: center;
  }
  .login {
    width: 100%;
    max-width: 100%;
  }
  .card.card-plain {
    max-width: 420px;
    margin-left: auto;
    margin-right: auto;
  }
}

/* Tablet: tarjeta flotante que resalta sobre el carrusel de fondo */
@include r.tablet {
  .login {
    background-color: transparent; // dejar ver el carrusel
  }
  .card.card-plain {
    background-color: var(--background);
    border-radius: 1rem;
    box-shadow: 0 16px 44px rgba(0, 0, 0, 0.45);
    padding: 1.5rem 1.25rem;

    :deep(.card-header) {
      background-color: transparent;
    }
  }
}

/* Desktop: panel de login a la derecha + carrusel a la izquierda */
@include r.desktop {
  .login {
    width: 35vw;
  }
}
</style>
